import React from "react";
import { Button, Card, CardBody, Collapse } from "reactstrap";
import axios from "axios/index";

class StaticReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      currentPage: 1,
      reviews: props.reviews,
      totalPages: props.totalPages,
    };
  }

  toggle = (e) => {
    e.preventDefault();
    if (this.state.reviews.length === 0) return;
    this.setState({ collapse: !this.state.collapse });
  };

  load = (page) => {
    axios
      .get(
        `/static_providers/reviews.json?pid=${this.props.provider_id}&page=${page}&per=10`
      )
      .then((res) => {
        this.setState({
          reviews: res.data.reviews,
          totalPages: res.data.total_pages,
          currentPage: res.data.current_page,
        });
      });
  };

  render() {
    const { reviews, currentPage, totalPages } = this.state;

    return (
      <div>
        <a href="#" className="text-nowrap" onClick={this.toggle}>
          {this.props.toggle_text}
        </a>

        <Collapse
          isOpen={this.state.collapse}
          style={{
            position: "absolute",
            zIndex: 999,
            width: "100%",
            left: 0,
          }}
        >
          <Card>
            <CardBody>
              <div className="row mb-3">
                <div className="col-10 h6">
                  {this.props.provider_name}
                </div>
                <div className="col-2 text-right">
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={this.toggle}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div
                className="pr-3 mb-3"
                style={{
                  maxHeight: 400,
                  overflowY: "auto",
                  marginRight: "-1.25rem",
                }}
              >
                {reviews.map((review, index) => (
                  <div key={index} className={`mb-3 pb-3 ${index < 9 ? 'border-bottom' : ''}`}>
                    <div className="row">
                      <div className="col-6">{`${this.props.rating_text} ${review.rating}/10`}</div>
                      <div className="col-6 text-right">
                        <div className="rating-author">{review.name}</div>
                        <div className="text-muted">
                          {" "}
                          {this.props.date_prefix} {review.date}
                        </div>
                      </div>
                    </div>
                    {review.message}
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {/* <div className="d-flex justify-content-between">
                <Button
                  color="primary"
                  className="btn btn-sm"
                  disabled={currentPage === 1}
                  onClick={() => this.load(currentPage - 1)}
                >
                  Previous
                </Button>
                <Button
                  color="primary"
                  className="btn btn-sm"
                  disabled={totalPages <= currentPage}
                  onClick={() => this.load(currentPage + 1)}
                >
                  Next
                </Button>
              </div> */}
              <div className="d-flex justify-content-center">
                <Button
                  color="primary"
                  className="btn btn-sm"
                  component="a"
                  href={this.props.provider_url}
                >
                  {this.props.provider_name}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Collapse>
      </div>
    );
  }
}

export default StaticReviews;
